import defaultMessages from './messages/defaultMessages';
import defaultRules from './rules/defaultRules';
import { ValidatorServiceImpl } from './services/validator-service';
import { ErrorUtils } from './utils/error-utils';
var useValidation = function (props) {
    var _a, _b, _c, _d;
    var isFormValid = false;
    var errors = [];
    var _e = props.state, state = _e === void 0 ? {} : _e;
    var fieldRules = props.fieldsRules;
    var locale = (_a = props.locale) !== null && _a !== void 0 ? _a : 'en';
    var baseRules = (_b = props.rules) !== null && _b !== void 0 ? _b : defaultRules;
    var messages = (_c = props.messages) !== null && _c !== void 0 ? _c : defaultMessages;
    var labels = (_d = props.labels) !== null && _d !== void 0 ? _d : {};
    var validatorService = new ValidatorServiceImpl(state, locale, baseRules, messages, labels);
    // function component is re-rendered if props or any use state vars is updated, so we trigger validation on each updates
    var result = validatorService.validate(fieldRules);
    errors = result.errors;
    isFormValid = result.isValid;
    var isFieldInError = function (fieldName) { return ErrorUtils.isFieldInError(errors, fieldName); };
    var getFailedRules = function () { return ErrorUtils.getFailedRules(errors); };
    var getErrorsForField = function (fieldName) { return ErrorUtils.getErrorsForField(errors, fieldName); };
    var getErrorsInField = function (fieldName) { return ErrorUtils.getErrorsInField(errors, fieldName); };
    var getErrorMessages = function (separator) {
        if (separator === void 0) { separator = '\n'; }
        return ErrorUtils.getErrorMessages(errors, separator);
    };
    var getFailedRulesInField = function (fieldName) { return ErrorUtils.getFailedRulesInField(errors, fieldName); };
    return {
        isFormValid: isFormValid,
        isFieldInError: isFieldInError,
        getFailedRules: getFailedRules,
        getFailedRulesInField: getFailedRulesInField,
        getErrorMessages: getErrorMessages,
        getErrorsForField: getErrorsForField,
        getErrorsInField: getErrorsInField
    };
};
export default useValidation;
